const Sider = ({ size, children }) => {
  const className = `app-sider app-sider-${size}`;

  return (
    <div className={className}>{children}</div>
  );
};

export default Sider;
